import { useQuery } from "@apollo/client/react";
import { BlockTitle, Page, Popup } from "framework7-react";

import { CategoryForm } from "@/components/CategoryForm";
import { createPage, PageComponentProps } from "@/factories/createPage";
import { getFragmentData } from "@/generated/graphql";
import { CategoryEnum, GetUserCategoryDocument, UserCategoryFragmentDoc } from "@/generated/graphql/graphql";
import { usePopupPageReady } from "@/hooks/usePopupPageReady";
import { AppBridgeProvider } from "@/providers/AppBridgeProvider";

export const CategoryEditPage = createPage("CategoryEditPage", PageComponent);

function PageComponent({ pageName, f7route, f7router, ...routeProps }: PageComponentProps) {
  const { getPageProps, isPageReady, swipeHandler } = usePopupPageReady(pageName);

  const { data } = useQuery(GetUserCategoryDocument, {
    skip: !isPageReady,
    variables: {
      categoryKey: f7route.params.categoryKey as CategoryEnum,
    },
  });
  const userCategory = getFragmentData(UserCategoryFragmentDoc, data?.userCategory);

  return (
    <AppBridgeProvider
      f7route={f7route}
      f7router={f7router}
      isVisible={isPageReady}
      {...routeProps}
    >
      <Popup
        backdrop
        data-component={pageName}
        style={{
          borderRadius: "var(--f7-sheet-border-radius) var(--f7-sheet-border-radius) 0 0",
          top: "calc(var(--f7-navbar-height) + var(--f7-safe-area-top))",
        }}
        {...getPageProps()}
      >
        <Page>
          {swipeHandler}
          <BlockTitle large>{userCategory?.name} の編集</BlockTitle>
          {userCategory && (
            <CategoryForm
              userCategory={userCategory}
              onCompleted={() => f7router.back()}
            />
          )}
        </Page>
      </Popup>
    </AppBridgeProvider>
  );
}
